<p-table styleClass="p-datatable-gridlines p-datatable-sm" [columns]="columnsTable" [value]="dataTable" dataKey="id"
    [tableStyle]="{ 'min-width': minWidth > 0 ? minWidth + 'rem' : '50rem' }" [(selection)]="selectionItem"
    [expandedRowKeys]="expandedRows" [defaultSortOrder]="sortOrder" filterMode="row" filterDisplay="row"
    [filterDelay]="200" [scrollable]="tableScrollConfig.enabled" [scrollHeight]="tableScrollConfig.height"
    [paginator]="enableLocalPagination" [rows]="100" [rowsPerPageOptions]="[100, 150, 200]"
    [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords}" #dt>
    <ng-template pTemplate="caption" *ngIf="showCaption">
        <section class="w-full flex align-items-center justify-content-between gap-2">

            <span>
                <p class="ml-2">{{selectionItem.length > 0 ? selectionItem.length : null }}
                    {{selectionItem.length > 1 ? 'solicitudes seleccionadas'
                    : selectionItem.length === 0 ? 'Seleccione al menos una solicitud para continuar.'
                    : 'solicitud seleccionada'}}
                    {{selectionItem.length === maxSelectedChecks && maxSelectedChecks > 0 ? '- Máximo permitido': ''}}
                </p>
            </span>

            <span class="flex align-items-center justify-content-end gap-2">
                <ng-container *ngIf="configButtonToCheck && selectionItem.length > 0">
                    <div *ngFor="let button of configButtonToCheck" tooltipStyleClass="custom-tooltip"
                        tooltipPosition="bottom"
                        [pTooltip]="isCheckActionBlocked?.disabled ? isCheckActionBlocked?.tooltip : null">
                        <p-button severity="info" size="small"
                            [styleClass]="['flex', 'md:hidden', button.color ?? 'morado'].join(' ')"
                            [icon]="button.icon" [disabled]="isCheckActionBlocked?.disabled"
                            (click)="onClickButtonToCheck.emit(button.namebutton)" />
                    </div>

                    <div *ngFor="let button of configButtonToCheck" tooltipStyleClass="custom-tooltip"
                        tooltipPosition="bottom"
                        [pTooltip]="isCheckActionBlocked?.disabled ? isCheckActionBlocked?.tooltip : null">
                        <p-button severity="info"
                            [styleClass]="['hidden', 'md:flex', button.color ?? 'morado'].join(' ')"
                            [label]="button.title" [icon]="button.icon" [disabled]="isCheckActionBlocked?.disabled"
                            (click)="onClickButtonToCheck.emit(button.namebutton)" />
                    </div>
                </ng-container>

                <ng-container *ngIf="configButtonToForm">
                    <p-button styleClass="hidden md:flex" [label]="configButtonToForm.title"
                        [icon]="configButtonToForm.icon" severity="info"
                        (click)="onClickButtonMassiveForm.emit(dataTable)" />
                    <p-button styleClass="flex md:hidden" [icon]="configButtonToForm.icon" severity="info"
                        (click)="onClickButtonMassiveForm.emit(dataTable)" size="small" />
                </ng-container>
            </span>

        </section>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="{{ col.type !== 'action_button' && col.type !== 'check' ? col.field : '' }}"
                (click)="setInitialSort(dt ,col.field)" *ngFor="let col of columnsTable" class="text-center"
                [style.width]="col.type === 'expanded' ? '3rem' : ''">
                <ng-container *ngIf="col.type === 'check'; else defaultColumn">
                    <p-tableHeaderCheckbox *ngIf="maxSelectedChecks === 0"
                        (click)="onChangeCheckbox.emit(selectionItem)" />
                    <p-checkbox *ngIf="maxSelectedChecks !== 0" binary="true" [(ngModel)]="isLimitedSelectionActive"
                        (onChange)="toggleLimitedSelection()" />
                </ng-container>
                <ng-template #defaultColumn>
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.type !== 'action_button' && col.type !== 'check'"
                        field="{{ col.field }}"></p-sortIcon>
                </ng-template>
            </th>
        </tr>
        <tr>
            <th *ngFor="let col of columns" class="text-center">
                <!-- Filtro solo si la columna tiene 'field' -->
                <ng-container *ngIf="col.type !== 'action_button' && col.type !== 'check'">
                    <p-columnFilter [field]="col.field" [type]="col.typeFilter" showClearButton="false" display="row"
                        matchMode="contains">
                        <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                            <input *ngIf="col.typeFilter === 'text'" type="text" pInputText [value]="value"
                                (input)="filterCallback($event.target.value)"
                                [placeholder]="'Filtrar por ' + col.header" />

                            <input *ngIf="col.typeFilter === 'numeric'" type="number" pInputText [value]="value"
                                (input)="filterCallback($event.target.value)"
                                [placeholder]="'Filtrar por ' + col.header" />
                        </ng-template>
                    </p-columnFilter>
                </ng-container>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
        <tr>
            <td *ngFor="let col of columns; let i = index" [ngClass]="{
               'text-right': col.type === 'money' || col.type === 'numeric',
               'text-left': col.type === 'text' || col.type === 'text_long' || col.type === 'btn_href'
                }" [ngStyle]="getColumnStyle(col.header)" [style.width]="getColumnWidth(col)"
                [style.paddingRight]="col.type === 'numeric' ? '35px' : ''">

                <ng-container *ngIf="col.type !== 'action_button'; else actionsTemplate">

                    <ng-container *ngIf="tablewithExpasionRow && col.type === 'expanded'">
                        <p-button type="button" [pRowToggler]="rowData" [text]="true" [rounded]="true" [plain]="true"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            [style]="{ 'outline': 'none', 'box-shadow': 'none' }" />
                    </ng-container>

                    <ng-container *ngIf="col.type === 'check'">
                        <p-tableCheckbox [value]="rowData" (click)="onChangeCheckbox.emit(selectionItem)"
                            [disabled]="isCheckboxDisabled(rowData)" />
                    </ng-container>

                    <ng-container *ngIf="col.type === 'field'">
                        <app-form-print-two [questions]="col | formatQuestion:rowData" [showButtonsSubmit]="false"
                            [formFilter]="false" [hideAlertToSubmit]="false" [showClearFilters]="false"
                            (onChangeSingleSelect)="onChangeField(rowIndex , $event)"
                            (onChangeValueField)="onChangeField(rowIndex , $event)"
                            (onChangeValueDateField)="onChangeField(rowIndex , $event)" #formPrint />
                    </ng-container>

                    <ng-container *ngIf="col.type === 'radio'">
                        <p-tableRadioButton [value]="rowData" (click)="onChangeCheckbox.emit(selectionItem)"
                            [disabled]="rowData.isDisabled" />
                    </ng-container>

                    <ng-container *ngIf="col.type === 'select'">
                        <p-dropdown styleClass="w-full" [(ngModel)]="rowData[col.field]" [options]="col.options"
                            optionLabel="text" placeholder="Seleccione una opción" optionValue="value"
                            appendTo="body"></p-dropdown>
                    </ng-container>

                    <ng-container *ngIf="col.type === 'text'">
                        <p style="line-height: 1.05;"> {{ rowData[col.field] }}</p>
                    </ng-container>

                    <ng-container *ngIf="col.type === 'text_long'">
                        <p class="minclt-table-text">
                            {{ rowData[col.field] }}
                        </p>
                    </ng-container>

                    <ng-container *ngIf="col.type === 'btn_href'">
                        <p class="minclt-btn-href" (click)="onClickButtonTable.emit({ data: rowData, col: col });"
                            [pTooltip]="'Haz clic aquí para desplegar el contenido del ' + columnsTable[i].header"
                            tooltipPosition="bottom" tooltipStyleClass="custom-tooltip">{{ rowData[col.field] }}</p>
                    </ng-container>

                    <ng-container *ngIf="col.type === 'date'">
                        {{ rowData[col.field] | date:'dd/MM/YYYY' }}
                    </ng-container>

                    <ng-container *ngIf="col.type === 'numeric'">
                        <span>{{ rowData[col.field] }}</span>
                        <!-- <span>{{ formatNumber(rowData[col.field]) }}</span> -->
                    </ng-container>

                    <ng-container *ngIf="col.type === 'money'">
                        <span style="margin-right: 0.25rem;" class="">$</span>
                        <span>{{ rowData[col.field] | number:'1.2-2' }}</span>
                    </ng-container>

                    <ng-container *ngIf="col.type === 'percentage'">
                        <p-progressBar [value]="rowData[col.field]" [ngClass]="{
                              'orientation-indicator': rowData[col.field] <= 50,
                              'rojo-fucsia': rowData[col.field] <= 50,
                              'naranja': rowData[col.field] > 50 && rowData[col.field] <= 75,
                              'amarillo': rowData[col.field] > 75 && rowData[col.field] < 90,
                              'verde-lima': rowData[col.field] >= 90 && rowData[col.field] <= (!col.maxProgressBarValue ? 100 : col.maxProgressBarValue),
                              'purpura': rowData[col.field] > (!col.maxProgressBarValue ? 100 : col.maxProgressBarValue),
                           }" />
                    </ng-container>
                </ng-container>
            </td>
            <ng-template #actionsTemplate>
                <td class="flex justify-content-end align-items-center gap-2 table-buttons-actions">
                    <ng-container *ngFor="let button of actionsTable">
                        <ng-container *ngIf="!button.visible || (button.visible && button.visible(rowData))">
                            <app-boton-svg [nombre]="button.icon"
                                [color]="!button.color ? button.typeButton : button.color(rowData)"
                                [pTooltip]="!button.tooltip ? button.textAction : button.tooltip(rowData)"
                                [isDisabled]="button.opacity?.(rowData) ?? false"
                                [style.pointer-events]="(button.opacity?.(rowData) ?? false) ? 'none' : 'auto'"
                                [borderRadius]="'8'" [size]="'28'" (click)="onButtonClick(button, rowData, rowIndex)"
                                tooltipPosition="bottom" />
                        </ng-container>
                    </ng-container>
                </td>
            </ng-template>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-rowData>
        <tr>
            <td [attr.colspan]="columnsTable.length">
                <div class="p-3">
                    <p-table [value]="rowData[nameToPropertySublist]" dataKey="id"
                        [columns]="columnsTableForExpasionRow">
                        <ng-template pTemplate="header" let-subColumns>
        <tr>
            <th *ngFor="let col of columnsTableForExpasionRow" class="text-center">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let col of columns;" class="text-center">
                <ng-container *ngIf="!col.type">
                    {{ rowData[col.field] }}
                </ng-container>
                <ng-container *ngIf="col.type === 'date'">
                    {{ rowData[col.field] | date:'dd/MM/YYYY' }}
                </ng-container>
                <ng-container *ngIf="col.type === 'money'">
                    {{ rowData[col.field] | currency }}
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td class="text-center font-semibold" [attr.colspan]="columnsTableForExpasionRow.length">
                No existe información disponible
            </td>
        </tr>
    </ng-template>
</p-table>
</div>
</td>
</tr>
</ng-template>
<ng-template pTemplate="emptymessage">
    <tr>
        <td class="text-center font-semibold" [attr.colspan]="columnsTable.length">No existe información disponible</td>
    </tr>
</ng-template>
</p-table>
<div *ngIf="configPaginator" class="flex sm:justify-content-end justify-content-center flex-wrap">
    <p-paginator [first]="configPaginator.first || 0" [rows]="configPaginator.rows || 0"
        [totalRecords]="configPaginator.total || 0" [showCurrentPageReport]="true" [showPageLinks]="false"
        [showJumpToPageDropdown]="false" currentPageReportTemplate="{first} - {last} Total: {totalRecords}"
        (onPageChange)="onChangePaginator.emit($event)"
        [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100, 200, 500, 1000]" />
</div>

<!-- TODO: propuesta -->
<!-- <p-inputGroup class="container-input-group">
  <input pInputText type="number" [min]="301" [disabled]="!isEnabled" placeholder="mayor a 300"/>
  <app-boton-svg [nombre]="'desbloquear'" [color]="isEnabled ? 'verde-inv' : 'purpura-inv'" [size]="'28'" [borderRadius]="'8'" [style.pointer-events]="'auto'" (click)="isEnabled = !isEnabled" />
</p-inputGroup> -->